/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var SharefileLogoIcon = createIcon("SharefileLogoIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#000';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("rect", {
    width: "48",
    height: "48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.236 21.343 1.535 2.659 5.848 10.13.33.574 2.304-1.329-5.411-9.376h5.411v-2.658H30.236ZM17.799 26.66l-1.536-2.658-5.848-10.13-.33-.575-2.304 1.329 5.411 9.376h-5.41v2.658h10.017Zm7.026-9.376h15.428v-2.659H29.428l2.708-4.686-.264-.154-2.039-1.178-5.008 8.677ZM23.21 30.716H7.78v2.661h10.825L15.9 38.064l.263.15 2.038 1.179 5.009-8.677Zm-4.604-10.774 1.535-2.658 5.848-10.13.331-.575-2.303-1.329-5.411 9.376-2.706-4.69-.264.154-2.039 1.178 5.009 8.674Zm10.822 8.116-1.533 2.658-5.847 10.13-.334.575 2.303 1.329 5.411-9.373 2.706 4.686.264-.15 2.039-1.179-5.009-8.676Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});